import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'
import router from '../../router'


const state = {
    users: [],
    user: [],
    userRoles: [],
    userProjects: [],
    projects: [],
    id: 0
}

const getters = {
    users: state => state.users,
    user: state => state.user,
    userRoles: state => state.userRoles,
    userProjects: state => state.userProjects,
    projects: state => state.projects
}

const actions = {

    loadUsers (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadUsers', { users: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    loadUser (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadUser', { user: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    createUser (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('createUser', { user: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    async saveUser({ commit, dispatch }, credentials) {
        try {
            const data = await appService.connectToServer(credentials);
            if (data.success) {
                commit('saveUser', {
                    User: data.User
                });
                dispatch('addMessage', data, { root: true });
                return data.User;
            }
            dispatch('addMessage', data, { root: true });
        } catch (err) {
            dispatch('addMessage', err.toString(), { root: true });
        }
    },

    deleteUser (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('deleteUser', { success: data.success, id: data.id  })
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }

        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    resetUser (context) {
        state.user = []
        state.userProjects = []
    },

}

const mutations = {

    saveUser(state, { User }) {
        state.user.requestLogCreate = User.requestLogCreate
        state.user.requestLogUpade = User.requestLogUpade
    },

    loadUsers (state, data) {
        state.users = data.users.result
    },
    loadUser (state, data) {
        state.user = data.user.result
        state.userRoles = data.user.data.roles
        state.projects = data.user.data.projects
        state.userProjects = data.user.data.userProjects
    },
    createUser (state, data) {
        state.userRoles = data.user.data.roles
        state.projects = data.user.data.projects
    },
    deleteUser (state, data) {
        let index = _.findIndex(state.users, function(o) { return o.id == data.id; });
        state.users.splice(index, 1)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
